var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93934 8.64642L3.6921 7.89734L3.69209 7.89734L3.69209 7.89734C1.33888 7.11293 0.162277 6.72073 0.162277 5.99997C0.162277 5.27921 1.33888 4.88701 3.6921 4.10261L12.2053 1.26488C13.8611 0.712955 14.689 0.43699 15.126 0.874006C15.563 1.31102 15.287 2.13892 14.7351 3.79471L11.8974 12.3079L11.8974 12.3079L11.8974 12.3079C11.113 14.6611 10.7208 15.8377 10 15.8377C9.27924 15.8377 8.88704 14.6611 8.10263 12.3079L7.35355 10.0606L11.7071 5.70708C12.0976 5.31656 12.0976 4.68339 11.7071 4.29287C11.3166 3.90234 10.6834 3.90234 10.2929 4.29287L5.93934 8.64642Z",
    fill: "#292c32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.7f90242afdb5908bba1b238ba57d3e64.svg";
export { ForwardRef as ReactComponent };